module.exports = __webpack_public_path__ + "static/poly-72-e1cdca093d60dbfe1e6839a6482a2325.png";